// src/components/Protected.jsx
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation, Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import { supabase } from "lib/supa";

export default function Protected({ children }) {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let unsub;
    (async () => {
      const { data } = await supabase.auth.getSession();
      setAuthed(!!data.session);
      setChecking(false);
      unsub = supabase.auth.onAuthStateChange((_e, session) => setAuthed(!!session)).data
        .subscription.unsubscribe;
    })();
    return () => {
      try {
        unsub?.();
      } catch {}
    };
  }, []);

  if (checking) {
    return (
      <MDBox display="flex" alignItems="center" justifyContent="center" height="60vh">
        <CircularProgress />
      </MDBox>
    );
  }

  if (!authed) {
    return <Navigate to="/authentication/sign-in" replace state={{ from: location }} />;
  }

  return children;
}

Protected.propTypes = {
  children: PropTypes.node.isRequired,
};
